import React from 'react';
import styled from 'styled-components';
import Router, { withRouter } from 'next/router';

// $FlowFixMe
import { Modal, Button } from '@bijie/react-bnb';

import Container from '../Container';
import FlexBox from '../FlexBox';
import Icon from '../Icon';
import withi18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import { gwGet } from '../../actions/actionsFactory/gwRequest';
import API_PATH from '../../actions/actionsFactory/apiPath';
import { Link } from '../../routes';


const FaceStatusBox = styled.div`
  width: 100%;
  background: #fff;
  ${({ shouldPadding }) => !shouldPadding ? 'padding-top: 40px;' : 'padding:0 0 45px 0;'}
  position: relative;
`;

const TipBox = styled(FlexBox)`
  width: 100%;
  padding: 15px;
  background: rgba(242, 48, 81, 0.2);
  border: 1px solid
  box-shadow:0px 10px 20px 0px rgba(0,192,135,0.1);
  border-radius:3px;
  font-size:14px;
  font-weight:400;
  line-height:20px;
  > .iconfont {
      margin-right: 15px;
  }
  > a {
      flex: 1;
      margin: 0;
      color:rgba(242,48,81,1);
      :hover {
          text-decoration: underline;
      }
  }
  > button {
      border: none;
      background: none;
      outline: none;
      cursor:pointer;
  }
`;

export const Content = styled.div`
  text-align: center;
  > h3 {
    font-size:24px;
    font-weight:500;
    color:rgba(33,40,51,1)!important;
    line-height:32px;
    margin: 10px 0 0;
  }
  > p {
    font-size:14px;
    font-family:${({ theme }) => theme.fontIBMRegular};
    color:rgba(72,81,93,1);
    line-height:18px;
    margin: 10px 0;
    text-align: left;
  }

 .alink {
   color: ${({ theme }) => theme.highlight};
   display: block;
   text-align: center;
   margin: 20px 0 0;
 }

`;

type Props = {
  i18n: Object,
  locale: string,
  router: Object,
}

type State = {
    shouldFaceValidate: boolean,
    faceStatusTip: string,
    faceStatus: number,
    faceType: string,
    faceId: string,
    isAbleUseOldAddress: boolean,
    isShowModal: boolean,
}

export default
@withi18n
@withRouter
class FaceStatus extends React.PureComponent<Props, State> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
    router: { pathname: '' },
  }

  state = {
    shouldFaceValidate: true,
    faceStatusTip: '',
    faceStatus: 0,
    faceType: '',
    faceId: '',
    isAbleUseOldAddress: false,
    isShowModal: false,
  }

  async componentDidMount() {
    try {
      const result = await gwGet(API_PATH.CHECK_ACCOUNT_WITHDRAW_FACE_STATUS);
      const { data, success } = result;
      if (success) {
        const {
          tip, status, id, type,
        } = data;
        this.setState({
          faceStatus: status,
          faceStatusTip: tip,
          faceId: id,
          faceType: type,
        });
      }
    } catch (error) {
      throw error;
    }
    try {
      const result = await gwGet(API_PATH.CHECK_ACCOUNT_WITHDRAW_HISTORY_ADDRESS_STATUS);
      const { data, success } = result;
      if (success) {
        this.setState({
          isAbleUseOldAddress: data,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  _getLinkUrl = () => {
    const { faceStatus, faceType, faceId } = this.state;
    const { locale } = this.props;
    if (faceStatus === 1) {
      return `/${locale}/usercenter/settings/select-identity-verification-type`;
    }
    if (faceStatus === 2) {
      return `/${locale}/usercenter/facial-info?type=${faceType}&id=${faceId}`;
    }
    return '';
  }

  _verify = () => {
    const link = this._getLinkUrl();
    if (link) Router.push(link);
  }

  _handleClick = () => {
    this.setState({ isShowModal: true });
  }

  render() {
    const {
      shouldFaceValidate, faceStatusTip, isAbleUseOldAddress, isShowModal,
    } = this.state;
    const { i18n, locale, router: { pathname } } = this.props;
    if (shouldFaceValidate && faceStatusTip) {
      return (
        <FaceStatusBox shouldPadding={pathname === '/usercenter/dashboard/overview'}>
          <Container>
            <TipBox align="center">
              <Icon type="information-o" size={22} color="#F23051" />
              <a onClick={this._handleClick}>{getLabel('exchange-withdraw-withdrawWarning', i18n)} »</a>
              <button type="button" onClick={() => this.setState({ shouldFaceValidate: false })}>
                <Icon type="close-strong" size={16} color="#F23051" />
              </button>
            </TipBox>
          </Container>
          <Modal
            visible={isShowModal}
            footer={false}
            centered={true}
            title={getLabel('exchange-withdraw-abnormalWithdrawalTitle', i18n)}
            onCancel={() => this.setState({ isShowModal: false })}
            style={{ width: '450px' }}
          >
            <Content>
              <p>{getLabel('exchange-withdraw-abnormalWithdrawalDesc2', i18n)}</p>
              {isAbleUseOldAddress && <p>{getLabel('exchange-withdraw-abnormalWithdrawalDesc3', i18n)}</p>}
              <FlexBox margin="30px 0 0" justify="center">
                <Button type="primary" size="lg" block={true} onClick={this._verify}>
                  {getLabel('exchange-withdraw-verifyNow', i18n)}
                </Button>
                {isAbleUseOldAddress && (
                <Link route={`/wallet`}>
                  <a className="alink">{getLabel('exchange-withdraw-useOldAddress', i18n)}</a>
                </Link>)}

              </FlexBox>
            </Content>
          </Modal>
        </FaceStatusBox>
      );
    }
    return null;
  }
}
